import { render, staticRenderFns } from "./AutoDeposit.vue?vue&type=template&id=e18ef5ca&"
import script from "./AutoDeposit.vue?vue&type=script&lang=ts&"
export * from "./AutoDeposit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports